import * as React from 'react'

import TerminationFormData from './TerminationFormData.interface'
import TerminationFormDataUpdate from './TerminationFormDataUpdate.type'
import TerminationFlowStatus, { terminationFlowOrder } from './TerminationFlowStatus.type'

import TerminationDate from './components/TerminationDate.component'
import TerminationReason from './components/TerminationReason.component'
import TerminationCheckVoluntary from './components/TerminationCheckVoluntary.component'
import TerminationFinalConfirmation from './components/TerminationFinalConfirmation.component'
import TerminationInitialConfirmation from './components/TerminationInitialConfirmation.component'

const indexOf = require('lodash/indexOf')

export interface TerminationFlowProps {
  terminationForm: TerminationFormData
  statusCallback: TerminationFormDataUpdate
}

interface TerminationFlowState {
  terminationState: TerminationFlowStatus
}

class TerminationFlow extends React.PureComponent<TerminationFlowProps> {
  state: TerminationFlowState = {
    terminationState: 'INITIAL_CONFIRMATION'
  }

  constructor(props) {
    super(props)

    this.handleFormUpdate = this.handleFormUpdate.bind(this)
    this.handlePreviousState = this.handlePreviousState.bind(this)
  }

  handleFormUpdate(terminationState: TerminationFlowStatus, terminationForm?: TerminationFormData) {
    this.setState({ terminationState }, () => {
      this.props.statusCallback(terminationState, terminationForm)
    })
  }

  handlePreviousState() {
    const previousState = this.previousState
    if (previousState) {
      this.setState({ terminationState: previousState })
    }
  }

  get previousState() {
    const { terminationState } = this.state

    const currentIndex = indexOf(terminationFlowOrder, terminationState)
    if (currentIndex >= 0) {
      const previousState = terminationFlowOrder[currentIndex - 1]
      return previousState
    }

    return null
  }

  render() {
    const { terminationForm } = this.props
    const { terminationState } = this.state

    return (
      <div className="d-flex flex-column align-items-center w-100">
        {terminationState === 'INITIAL_CONFIRMATION' && (
          <TerminationInitialConfirmation
            terminationForm={terminationForm!}
            statusCallback={this.handleFormUpdate}
          />
        )}

        {terminationState === 'CHECK_VOLUNTARY' && (
          <TerminationCheckVoluntary
            terminationForm={terminationForm!}
            statusCallback={this.handleFormUpdate}
          />
        )}

        {terminationState === 'TERMINATION_DATE' && (
          <TerminationDate
            terminationForm={terminationForm!}
            statusCallback={this.handleFormUpdate}
          />
        )}

        {terminationState === 'TERMINATION_REASON' && (
          <TerminationReason
            terminationForm={terminationForm!}
            statusCallback={this.handleFormUpdate}
          />
        )}

        {terminationState === 'FINAL_CONFIRMATION' && (
          <TerminationFinalConfirmation
            terminationForm={terminationForm!}
            statusCallback={this.handleFormUpdate}
          />
        )}

        {terminationState !== 'INITIAL_CONFIRMATION' &&
          <a className="cursor-pointer mt-2" onClick={this.handlePreviousState}>
            <u>Back</u>
          </a>
        }
      </div>
    )
  }
}

export default TerminationFlow


// WEBPACK FOOTER //
// ./src/routes/terminations/termination-flow/index.tsx